import { render } from "./dental_diagnosis.vue?vue&type=template&id=2204c5c5&scoped=true"
import script from "./dental_diagnosis.vue?vue&type=script&lang=js"
export * from "./dental_diagnosis.vue?vue&type=script&lang=js"

import "./dental_diagnosis.vue?vue&type=style&index=0&id=2204c5c5&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2204c5c5"]])

export default __exports__